import React, { useContext } from 'react';
import {
  DetailContext,
  DetailHandle,
  PrimaryDetailActionbarButton,
  SecondaryDetailActionbarButton,
  UserContext,
} from '@eas/common-web';
import {
  ApproveViewingRequestButton,
  RejectViewingRequestButton,
} from '@composite/viewing-requests/dialog-actions/change-viewing-request-state-hook';
import { ViewingRequest } from '@models';
import { Role, ViewingRequestState } from '@enums';
import { PrintPhysicalDetailsButton } from './dialog-actions/print-physical-details-button';
import { VerifyDataBoxButton } from './dialog-actions/verify-data-box-button';

export function ActionBar() {
  const { source } = useContext<DetailHandle<ViewingRequest>>(DetailContext);
  const { hasPermission } = useContext(UserContext);

  const dataBoxId = source?.data?.requester?.contact?.dataBox?.identifier;
  const viewingMethod = source?.data?.viewingMethod;
  const state = source?.data?.state;
  const physicalViewing = source?.data?.physicalViewing;
  const showChangeStateButtons =
    source?.data &&
    source.data.state === ViewingRequestState.NEW &&
    hasPermission(Role.VIEWING_REQUEST_MANAGER);

  return (
    <>
      {dataBoxId && (
        <VerifyDataBoxButton
          dataBoxId={dataBoxId}
          ButtonComponent={PrimaryDetailActionbarButton}
        />
      )}

      {viewingMethod === 'PHYSICAL' &&
        state === ViewingRequestState.PROCESSING &&
        physicalViewing && <PrintPhysicalDetailsButton />}

      {showChangeStateButtons && (
        <>
          <ApproveViewingRequestButton
            viewingRequest={source.data!}
            ButtonComponent={PrimaryDetailActionbarButton}
          />

          <RejectViewingRequestButton
            viewingRequest={source.data!}
            ButtonComponent={SecondaryDetailActionbarButton}
          />
        </>
      )}
    </>
  );
}
